import React from 'react';

import { UserImportFieldOptionsModel } from '../../../models/ApiResponseModels/UserImportFieldOptionsModel';
import UploadFieldOptions from './UploadFieldOptions';

interface Step3Props {
    userImportOptions: UserImportFieldOptionsModel[]
    setUserImportOptions: (formFields: UserImportFieldOptionsModel[]) => void
    responseError: {message: string, code: number}
}


const Step3 = ({userImportOptions, setUserImportOptions, responseError}: Step3Props) => {
    const formFields = userImportOptions.filter(f=>!f.isRequired)
    .sort(({position:a}, {position:b}) => a-b);

    const updateField = (propertyName:string, value:number) => {
        const itemToChange = formFields.find(f=>f.propertyName == propertyName);
        itemToChange.action = value;
        setUserImportOptions(formFields);
    }

    const options = [
        {val:0, name:"Add If Empty"},
        {val:1, name:"Overwrite"},
        {val:2, name:"Ignore"}
    ]

    return (
        <React.Fragment>
            
            <h3>Review Settings</h3>
            <>
            { responseError 
            
            ? <p>{responseError.message}</p>
            : <div className="user-upload-fields-container">

            <h2>Upload Field Options</h2>   
            
            <UploadFieldOptions
                formFields={formFields}
                options={options}
                optionFilter={(option: any, propertyName: string) => !(propertyName === 'Groups' && option.val === 0)}
                updateField={updateField}

            /> 
            </div>
        }
        </>
            
        </React.Fragment>
    );
};

export default Step3;

